import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1bc8befc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "topay"
};
const _hoisted_2 = {
  class: "topay-header"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 支付 ");
const _hoisted_4 = {
  class: "pay_bottom"
};
const _hoisted_5 = {
  class: "total_num"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PaymethodList = _resolveComponent("PaymethodList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "drop-back-icon",
    onClick: _cache[0] || (_cache[0] = $event => $options.close())
  }), _hoisted_3]), _createVNode(_component_PaymethodList, {
    list: $props.list,
    onSetPayType: $options.setPayType
  }, null, 8, ["list", "onSetPayType"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, " 总额：¥" + _toDisplayString($props.orderInfo.apply_pay_amount || $props.orderInfo.pay_amount), 1), _createElementVNode("div", {
    class: "pay_endbtn",
    id: "pay_action",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.payClick && $options.payClick(...args))
  }, "确认支付")])]);
}